var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-upload" },
    [
      _c(
        "el-upload",
        {
          attrs: {
            disabled: _vm.disabled,
            "auto-upload": _vm.autoUpload,
            action: _vm.action,
            name: _vm.name,
            data: _vm.data,
            "http-request": _vm.request,
            "file-list": _vm.defaultFileList,
            "show-file-list": _vm.showFileList,
            drag: _vm.drag,
            accept: _vm.accept,
            multiple: _vm.multiple,
            limit: _vm.limit,
            "before-upload": _vm.before,
            "on-success": _vm.success,
            "on-remove": _vm.remove,
            "on-error": _vm.error,
            "on-preview": _vm.handlePreview,
            "on-exceed": _vm.handleExceed,
          },
          scopedSlots: _vm._u([
            {
              key: "tip",
              fn: function () {
                return [
                  _vm.tip
                    ? _c("div", { staticClass: "el-upload__tip" }, [
                        _vm._v(_vm._s(_vm.tip)),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._t("default", function () {
            return [
              _c(
                "el-button",
                { attrs: { type: "primary", disabled: _vm.disabled } },
                [_vm._v("上传文件")]
              ),
            ]
          }),
        ],
        2
      ),
      _c(
        "span",
        { staticStyle: { display: "none !important" } },
        [
          _c("el-input", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }